export default __webpack_public_path__ + "static/media/NO.c4db303e.svg";